import Collapse from './Collapse';

export default Collapse;
export var Panel = Collapse.Panel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-collapse@1.11.8@rc-collapse/es/index.js
// module id = 219
// module chunks = 0